import React from "react";

import { DropzoneProvider } from "core/Dropzone/hooks/useDropzone";
import { PhotoUploadProvider } from "frontend/hooks/usePhotoUpload";

const PhotoUploadRoutesProviders = ({ children }) => (
    <PhotoUploadProvider>
        <DropzoneProvider>{children}</DropzoneProvider>
    </PhotoUploadProvider>
);

export default PhotoUploadRoutesProviders;
